import { WorkZoneProvider } from 'components/WorkZone/WorkZoneProvider';

export function WorkZone({
	children,
	endpoint
}: React.PropsWithChildren<{ endpoint?: string }>) {
	return <WorkZoneProvider endpoint={endpoint}>{children}</WorkZoneProvider>;
}
